import { Reducer } from 'umi';

const namespace = 'opinionOrderLoading';

type stateType = {
  topicTrackingTimeline: number;
  topicTrackingList: number;
  trendingVideo: number;
  trendingPosts: number;
};

const customModel: {
  namespace: string;
  state: stateType;
  reducers: {
    change: Reducer<stateType>;
    resetLoading: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    topicTrackingTimeline: 1,
    topicTrackingList: 1,
    trendingVideo: 0,
    trendingPosts: 0,
  },
  reducers: {
    change(state: stateType, { key, value }) {
      return {
        ...state,
        [key]: value,
      };
    },
    resetLoading(state: stateType, { keys, defaultValue = 1 }) {
      if (!keys) return state;

      const obj = keys.reduce(
        (pre: any, cur: string) => ({ ...pre, [cur]: defaultValue }),
        {},
      );

      return {
        ...state,
        ...obj,
      };
    },
  },
};

export default customModel;
